//--------------------------------------------------------------------//
//******************** email-settings request helper *******************//
//--------------------------------------------------------------------//
// Shared low-level fetch helper for talking to conversation-nodejs's
// /email/* REST API (unlike SIP trunks, this lives in the same backend
// service as gudhub-messenger, not a separate one - see
// emailSettings.service.js). Mirrors sipTrunks.request.js's shape.
import { GUDHUB_SETTINGS } from '../../config.js';

export async function request(endpoint, options = {}) {
    const url = GUDHUB_SETTINGS.conversation_server_url + endpoint;
    const token = await gudhub.getToken();

    const response = await fetch(url, {
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        ...options
    });

    if (response.status === 204) {
        return null;
    }

    const result = await response.json();

    if (!response.ok) {
        throw new Error(result.message || 'Email settings request error');
    }

    return result;
}
